// extracted by mini-css-extract-plugin
export default {"root":"q30XetMm0iQvaAzj6Pjz"};